import React from 'react';
import { PlayCircle } from 'lucide-react';
import { useExerciseDemo } from '../contexts/ExerciseDemoContext';

interface ExerciseDemoButtonProps {
  name: string;
  className?: string;
  /** Full tailwind size classes for the icon, e.g. "w-4 h-4". Defaults to "w-5 h-5". */
  iconClassName?: string;
}

/**
 * A play button that opens the exercise demo. Renders nothing when the exercise
 * has no demo available (e.g. custom user exercises), so the icon only appears
 * where there is something to show.
 */
export function ExerciseDemoButton({
  name,
  className = '',
  iconClassName = 'w-5 h-5',
}: ExerciseDemoButtonProps) {
  const { hasDemo, openDemo } = useExerciseDemo();
  if (!hasDemo(name)) return null;

  return (
    <button
      type='button'
      onClick={(e) => {
        e.stopPropagation();
        openDemo(name);
      }}
      className={`inline-flex items-center justify-center text-blue-500 hover:text-blue-600 active:text-blue-700 touch-manipulation flex-shrink-0 ${className}`}
      aria-label={`Ver demo de ${name}`}
    >
      <PlayCircle className={iconClassName} />
    </button>
  );
}
